import { IResponse } from "@app/common/types/http";
import { HTTP_SECURITY } from "@app/config/axios";
import { IReassignToken, IReassignTokenPayload } from "./types";

export const reassignToken = async (payload: IReassignTokenPayload, token: string) => {
  const axiosInstance = HTTP_SECURITY(token);

  const response = await axiosInstance.post<IResponse<IReassignToken>>("/reassignToken/", payload);

  return response.data;
};
